import React from "react";
import Card from "@/components/common/card/Card";
import Input from "@/components/common/input/Input";
import styles from "../../SimulationConfiguration.module.css";
import type { testSettingsProps } from "./types.props";

const TestSettings: React.FC<testSettingsProps> = ({ settings, onUpdate }) => {
    const handleWeightChange = (
        difficulty: "easy" | "medium" | "hard",
        value: string,
    ) => {
        if (/^\d*\.?\d*$/.test(value)) {
            const newWeights = {
                ...settings.weights,
                [difficulty]: Number(value) || 0,
            };
            onUpdate("weights", newWeights);
        }
    };

    return (
        <Card>
            <h3 className={styles["card-title"]}>
                Configuración General de la Prueba
            </h3>
            <div className={styles["settings-grid"]}>
                <Input
                    label="Peso (Fácil)"
                    id="weight_easy"
                    type="text"
                    inputMode="decimal"
                    value={String(settings.weights.easy)}
                    onChange={(e) => handleWeightChange("easy", e.target.value)}
                />
                <Input
                    label="Peso (Medio)"
                    id="weight_medium"
                    type="text"
                    inputMode="decimal"
                    value={String(settings.weights.medium)}
                    onChange={(e) => handleWeightChange("medium", e.target.value)}
                />
                <Input
                    label="Peso (Difícil)"
                    id="weight_hard"
                    type="text"
                    inputMode="decimal"
                    value={String(settings.weights.hard)}
                    onChange={(e) => handleWeightChange("hard", e.target.value)}
                />
            </div>
        </Card>
    );
};

export default TestSettings;
